/**
 * InheritanceEdge — React Flow custom edge for a MERODE inheritance (phase 6b).
 *
 * Pixel-faithful port of `components/EDG/inheritance.js`. As with DependencyEdge,
 * the geometry + marker id + (no) labels are derived in `EdgFlow.deriveEdges`
 * (`edgeMapping.ts`); this is the thin renderer registered as `edgeTypes
 * .inheritance`.
 *
 * Marker semantics replicated from `inheritance.js` (ALWAYS has a marker, both
 * notations — unlike dependencies):
 *  - source marker = inherit triangle (△ hollow) for a concrete supertype, OR in
 *    ANY UML inheritance.
 *  - inherit-abstract (▲ filled) ONLY when the supertype is abstract AND notation
 *    is MERODE.
 *  - No target marker, no labels.
 *
 * Classic JSX runtime (app-wide esbuild transform) needs React in scope.
 */
import React from 'react';
import type { EdgeProps } from '@xyflow/react';
import EdgeBase, { type EdgeFlowEdge } from './EdgeBase';

export default function InheritanceEdge(props: EdgeProps<EdgeFlowEdge>) {
  return <EdgeBase {...props} />;
}
